import MaterialTable from "material-table";
import React from "react";
import { connect } from "react-redux";
import { GET_USER_FROM_ADMIN } from "../graphql/queries";

import {
  DELETE_USER,
  UPDATE_USER,
} from "../graphql/mutation";
import { useMutation, useQuery } from "@apollo/client";
import { LinearProgress } from "@material-ui/core";
import { optionTableUser } from "./OptionTable.component";

const TableSPV = ({ columnData }) => {
  const { data, loading, refetch } = useQuery(GET_USER_FROM_ADMIN, {
    pollInterval: 1000,
  });

  const [updateUser] = useMutation(UPDATE_USER);

  const [deleteUser] = useMutation(DELETE_USER);

  if (loading) return <LinearProgress />;

  const plannerData = data.findAllUser
    .filter(({ role }) => role === "worker" || role === "planner")
    .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
    .map((o) => ({ ...o }));
  return (
    <div className="max-width-section p-5">
      <MaterialTable
        columns={columnData}
        data={plannerData}
        title="Planner and Worker List"
        options={optionTableUser}
        editable={{
            onRowUpdate: (newNewData, oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  const dataUpdate = [...plannerData];
                  const index = oldData.tableData.id;
                  dataUpdate[index] = newNewData;
                  updateUser({ variables: { ...newNewData } });
                  resolve();
                }, 200);
              }),
          onRowDelete: (oldData) =>
            new Promise((resolve, reject) => {
              setTimeout(() => {
                deleteUser({ variables: { id: oldData.id } });
                // refetch();
                resolve();
              }, 200);
            }),
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    columnData: state.spv.columnDataUser,
  };
};

export default connect(mapStateToProps, null)(TableSPV);
